/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InactivityAliases {
  INACTIVITY_0 = 'inactivity-0',
  LAYOUT_INACTIVITY = 'layout-inactivity',
}
export { InactivityAliases };
